import { render, staticRenderFns } from "./InstrumentButton.vue?vue&type=template&id=4ae0dd73&scoped=true&"
import script from "./InstrumentButton.vue?vue&type=script&lang=js&"
export * from "./InstrumentButton.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentButton.vue?vue&type=style&index=0&id=4ae0dd73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0dd73",
  null
  
)

export default component.exports